import { ChatMessage } from '../store/chatStore';
import styles from './MessageBubble.module.scss';

interface Props {
  message: ChatMessage;
}

export function MessageBubble({ message }: Props) {
  const isAI = message.role === 'ai';

  if (isAI) {
    return (
      <div className={styles.aiGroup}>
        <span className={styles.aiLabel}>Paymob AI</span>
        <div
          className={`${styles.bubble} ${styles.aiBubble} ${message.isError ? styles.errorBubble : ''}`}
        >
          {message.content}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.userGroup}>
      <div className={`${styles.bubble} ${styles.userBubble}`}>
        {message.content}
      </div>
    </div>
  );
}
